import React from 'react';
import { Link } from 'react-router-dom';
import { INSIGHT_SEVERITY_CLASS, buildEventsDrilldownUrl } from '../summaryFormatters';

/**
 * Карточка инсайта из insightModel.buildInsightCard: заголовок, текущее
 * значение с единицей, чип изменения, «Было …» или «Нет сравнения», пояснение.
 */
const InsightCard = ({ card }) => {
  const href = buildEventsDrilldownUrl(card.drilldown);
  return (
    <div className={`sum-insight ${INSIGHT_SEVERITY_CLASS[card.severity] || 'sum-insight--observe'}`}>
      <div className="sum-insight-title">{card.title}</div>
      {card.current && (
        <div className="sum-insight-value">
          <b>{card.current.value}</b>
          {card.current.unit && <span> {card.current.unit}</span>}
          {card.change && (
            <span className={`sum-insight-chip sum-insight-chip--${card.change.tone}`}>{card.change.label}</span>
          )}
        </div>
      )}
      {card.previousText && <p className="sum-insight-text">{card.previousText}</p>}
      {card.secondary && <p className="sum-insight-text">{card.secondary}</p>}
      {card.factsLine && <p className="sum-insight-facts">{card.factsLine}</p>}
      {href && <Link className="sum-link" to={href}>Посмотреть связанные события</Link>}
    </div>
  );
};

export default InsightCard;
